<template>
  <v-timeline align-top dense>
    <v-timeline-item v-for="(item, i) in apiItems" :key="i" fill-dot>
      <span slot="icon">{{ i + 1 }}</span>
      <!--Todo: Separate this into its own component-->
      <v-flex xs12 class="beez-padding-tb">
        <v-toolbar class="secondary" dense>
          <v-flex>
            <div class="text-lg-left beez-bold ">Step {{ i + 1 }}</div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="saveAutomation()">
            <v-icon>save</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-card-title color="secondary">
            <v-flex d-flex xs12>
              <v-text-field
                placeholder="Description"
                v-model="item.description"
                outline
                single-line
              />
            </v-flex>
            <v-flex d-flex xs2>
              <v-select
                :items="apiMethods"
                v-model="item.method"
                outline
                single-line
              />
            </v-flex>
            <v-flex d-flex xs10>
              <v-text-field
                placeholder="URL"
                v-model="item.url"
                @input="urlEdited(i)"
                outline
                single-line
              />
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-tabs grow>
              <v-tab v-for="(tab, j) in tabs" :key="j">
                {{ tab }}
              </v-tab>
              <v-tabs-items>
                <!--Todo: Each Tab item as its own component?-->
                <v-tab-item>
                  <v-container>
                    <v-layout>
                      <v-flex>
                        <v-data-table
                          :headers="paramsHeaders"
                          :items="item.params"
                          disable-initial-sort
                          hide-actions
                        >
                          <template slot="items" slot-scope="props">
                            <td class="text-xs-left">
                              <v-edit-dialog
                                :return-value.sync="props.item.key"
                                lazy
                                persistent
                              >
                                {{ props.item.key }}
                                <v-text-field
                                  slot="input"
                                  v-model="props.item.key"
                                  @input="paramEdited(i)"
                                  label="Params"
                                  autofocus
                                  clearable
                                  single-line
                                />
                              </v-edit-dialog>
                            </td>
                            <td class="text-xs-left">
                              <v-edit-dialog
                                :return-value.sync="props.item.value"
                                lazy
                                persistent
                              >
                                {{ props.item.value }}
                                <v-text-field
                                  slot="input"
                                  v-model="props.item.value"
                                  @input="paramEdited(i)"
                                  label="Params"
                                  autofocus
                                  clearable
                                  single-line
                                />
                              </v-edit-dialog>
                            </td>
                            <td class="justify-center layout px-0">
                              <v-icon
                                v-if="
                                  props.index !== apiItems[i].params.length - 1
                                "
                                small
                                @click="deleteParam(i, props.index)"
                              >
                                delete
                              </v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12 sm4>
                        <v-select
                          :items="authTypes"
                          v-model="item.auth.type"
                          outline
                          single-line
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <div v-if="item.auth.type === 'Bearer Token'">
                          <v-text-field
                            label="Token"
                            v-model="item.auth.data.bearerToken"
                            outline
                            single-line
                          />
                        </div>
                        <div v-if="item.auth.type === 'Basic'">
                          <v-text-field
                            label="Username"
                            v-model="item.auth.data.username"
                            outline
                            single-line
                          />
                          <v-text-field
                            label="Password"
                            v-model="item.auth.data.password"
                            outline
                            single-line
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-layout>
                      <v-flex>
                        <v-data-table
                          :headers="headerHeaders"
                          :items="item.headers"
                          disable-initial-sort
                          hide-actions
                        >
                          <template slot="items" slot-scope="props">
                            <td class="text-xs-left">
                              <v-edit-dialog
                                :return-value.sync="props.item.key"
                                lazy
                                persistent
                              >
                                {{ props.item.key }}
                                <v-text-field
                                  slot="input"
                                  v-model="props.item.key"
                                  @input="headerEdited(i)"
                                  label="Headers"
                                  autofocus
                                  clearable
                                  single-line
                                />
                              </v-edit-dialog>
                            </td>
                            <td class="text-xs-left">
                              <v-edit-dialog
                                :return-value.sync="props.item.value"
                                lazy
                                persistent
                              >
                                {{ props.item.value }}
                                <v-text-field
                                  slot="input"
                                  v-model="props.item.value"
                                  @input="headerEdited(i)"
                                  label="Headers"
                                  autofocus
                                  clearable
                                  single-line
                                />
                              </v-edit-dialog>
                            </td>
                            <td class="justify-center layout px-0">
                              <v-icon
                                v-if="
                                  props.index !== apiItems[i].headers.length - 1
                                "
                                small
                                @click="deleteHeader(i, props.index)"
                              >
                                delete
                              </v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-layout>
                      <v-flex>
                        <v-textarea
                          label="Request Body"
                          v-model="item.body"
                          outline
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <template v-for="(pass, j) in item.pass">
                    <v-layout
                      align-center
                      justify-center
                      row
                      fill-height
                      wrap
                      :key="j"
                    >
                      <v-flex xs1>
                        <v-chip> ${{ j }}</v-chip>
                      </v-flex>
                      <v-flex xs10>
                        <br />
                        <v-text-field
                          label="Variable"
                          v-model="item.pass[j]"
                          @input="passEdited(i)"
                          outline
                        />
                      </v-flex>
                      <v-flex xs1>
                        <v-icon
                          v-if="j !== apiItems[i].pass.length - 1"
                          @click="deletePass(i, j)"
                        >
                          delete
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-timeline-item>
    <v-timeline-item fill-dot>
      <v-btn @click="addStep">
        <v-icon>mdi-plus</v-icon>
        <span class="ml-2"> Add API Step</span>
      </v-btn>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
export default {
  data() {
    return {
      apiItems: [
        {
          url: '',
          description: '',
          method: 'GET',
          params: [
            {
              key: '',
              value: ''
            }
          ],
          auth: {
            type: 'No Auth',
            data: {}
          },
          headers: [
            {
              key: '',
              value: ''
            }
          ],
          body: '',
          pass: ['']
        }
      ],
      apiMethods: ['GET', 'POST', 'PUT', 'DELETE'],
      authTypes: ['No Auth', 'Basic', 'Bearer Token'],
      tabs: [
        'Params',
        'Authorisation',
        'Headers',
        'Body',
        'Positional arguments'
      ],
      paramsHeaders: [
        {
          text: 'Key',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Value',
          value: 'value',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'delete',
          align: 'left',
          sortable: false,
          width: 48
        }
      ],
      headerHeaders: [
        {
          text: 'Key',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Value',
          value: 'value',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'delete',
          align: 'left',
          sortable: false,
          width: 48
        }
      ]
    }
  },
  methods: {
    urlEdited(index) {
      let queryString = this.apiItems[index].url
        .split('?')
        .slice(1)
        .join('?')
      this.apiItems[index].params =
        queryString.length === 0
          ? []
          : queryString.split('&').map(param => {
              let splitKeyValue = param.split('=')
              let key = splitKeyValue[0]
              let value = splitKeyValue.slice(1).join('=')
              return { key, value }
            })
      this.apiItems[index].params.push({
        key: '',
        value: ''
      })
    },

    paramEdited(index) {
      this.generateUrlFromParameter(index)
      let lastParam = this.apiItems[index].params[
        this.apiItems[index].params.length - 1
      ]
      if (lastParam.key.length > 0 || lastParam.value.length > 0) {
        this.apiItems[index].params.push({
          key: '',
          value: ''
        })
      }
    },

    headerEdited(index) {
      let lastHeader = this.apiItems[index].headers[
        this.apiItems[index].headers.length - 1
      ]
      if (lastHeader.key.length > 0 || lastHeader.value.length > 0) {
        this.apiItems[index].headers.push({
          key: '',
          value: ''
        })
      }
    },

    passEdited(index) {
      let lastPass = this.apiItems[index].pass[
        this.apiItems[index].pass.length - 1
      ]
      if (lastPass.length > 0) {
        this.apiItems[index].pass.push('')
      }
    },

    deleteParam(itemIndex, paramIndex) {
      this.apiItems[itemIndex].params.splice(paramIndex, 1)
      this.generateUrlFromParameter(itemIndex)
    },

    deleteHeader(itemIndex, headerIndex) {
      this.apiItems[itemIndex].headers.splice(headerIndex, 1)
    },

    deletePass(itemIndex, passIndex) {
      this.apiItems[itemIndex].pass.splice(passIndex, 1)
    },

    generateUrlFromParameter(index) {
      let firstParam = this.apiItems[index].params[0]
      this.apiItems[index].url = `${
        this.apiItems[index].url.split('?')[0]
      }?${this.apiItems[index].params
        .slice(1)
        .reduce((accumulator, param, i) => {
          if (param.key.length > 0 || param.value.length > 0) {
            return `${accumulator}&${param.key}=${param.value}`
          } else {
            return accumulator
          }
        }, `${firstParam.key}=${firstParam.value}`)}`
    },

    addStep() {
      this.apiItems.push({
        url: '',
        description: '',
        method: 'GET',
        params: [
          {
            key: '',
            value: ''
          }
        ],
        auth: {
          type: 'No Auth',
          data: {}
        },
        headers: [
          {
            key: '',
            value: ''
          }
        ],
        body: '',
        pass: ['']
      })
    },

    saveAutomation() {
      this.$store
        .dispatch(
          'saveApiAutomation',
          {
            apiAutomationName: 'TestName',
            apiAutomationDescription: 'TestDescription',
            apiAutomationJson: JSON.stringify(this.apiItems)
          },
          this
        )
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>

<style scoped></style>
